import { connect } from "react-redux";

import GlobalHistogramTable from "../../components/visualizations/global_histogram_table";

const mapStateToProps = (state) => {
  const ld = state.main.loading.loadedData;
  if (!(ld.mainTableData)) { return {}; }

  const data = ld.mainTableData;

  return { data };
};

const mapDispatchToProps = () => ({
});

export default connect(mapStateToProps, mapDispatchToProps)(GlobalHistogramTable);
